import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/active-clock.svg'
import _imports_1 from '@/assets/img/unactive-clock.svg'


const _withScopeId = n => (_pushScopeId("data-v-a17360fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-max-w-[630px] tw-w-full mainWrapper" }
const _hoisted_2 = { class: "tw-w-full tw-flex tw-items-center tw-justify-between" }
const _hoisted_3 = { class: "tw-flex tw-gap-[15px] tw-items-center" }
const _hoisted_4 = { class: "tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-[600] tw-leading-[130%]" }
const _hoisted_5 = {
  key: 0,
  class: "tw-font-[400]"
}
const _hoisted_6 = { class: "tw-font-[400]" }
const _hoisted_7 = { class: "tw-flex tw-items-center tw-gap-[15px]" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M11.8741 6.39285L6.38429 0.169354C6.33485 0.117097 6.27527 0.0754726 6.2092 0.0470253C6.14312 0.0185781 6.07194 0.00390599 6 0.00390599C5.92806 0.00390598 5.85688 0.0185781 5.7908 0.0470253C5.72473 0.0754725 5.66515 0.117097 5.61571 0.169354L0.125859 6.39285C0.081969 6.44228 0.0483386 6.49995 0.02692 6.56249C0.00550146 6.62503 -0.00327902 6.69121 0.00108975 6.75717C0.0065009 6.82367 0.0251891 6.8884 0.056049 6.94755C0.086909 7.0067 0.129313 7.05906 0.180757 7.10154L1.10405 7.87511C1.15449 7.91873 1.21315 7.95181 1.27658 7.97238C1.34002 7.99295 1.40693 8.00061 1.47337 7.99488C1.53949 7.9901 1.604 7.97219 1.66313 7.9422C1.72225 7.91221 1.77481 7.87074 1.81773 7.82021L5.91516 3.10393C5.94039 3.07894 5.97447 3.06492 6.00998 3.06492C6.04549 3.06492 6.07957 3.07894 6.10481 3.10393L10.1823 7.82021C10.2629 7.91657 10.377 7.97895 10.5017 7.99489C10.5678 8.00129 10.6345 7.99443 10.6979 7.97472C10.7613 7.95501 10.8202 7.92284 10.871 7.8801L11.8192 7.10154C11.8707 7.05906 11.9131 7.0067 11.9439 6.94755C11.9748 6.8884 11.9935 6.82367 11.9989 6.75717C12.0033 6.69121 11.9945 6.62503 11.9731 6.56249C11.9517 6.49995 11.918 6.44229 11.8741 6.39285Z",
  fill: "#387DFF"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-[20px]" }
const _hoisted_11 = { class: "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-[600] tw-leading-[100%] tw-tracking-[1px] tw-uppercase" }
const _hoisted_12 = { class: "assessmentHistory" }
const _hoisted_13 = { class: "tw-flex tw-gap-[15px] tw-items-center" }
const _hoisted_14 = {
  key: 0,
  class: "dropdown-button-arrow-img",
  src: _imports_0
}
const _hoisted_15 = {
  key: 1,
  class: "dropdown-button-arrow-img",
  src: _imports_1
}
const _hoisted_16 = { class: "tw-flex tw-gap-[10px] tw-items-center" }
const _hoisted_17 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-[500] tw-leading-[normal]" }
const _hoisted_18 = {
  key: 0,
  class: "tw-text-[#878787] tw-font-[400] tw-leading-[normal]"
}
const _hoisted_19 = {
  key: 1,
  class: "tw-text-[#878787] tw-font-[400] tw-leading-[normal]"
}

import { Ref, ref, watch } from "vue";
import ToggleIcon from "../svgs/toggleIcon.vue";
import AssessmentStatus from "./assessmentStatus.vue";
import { assessmentStatus } from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";
import AssessmentChecklistStatusTag from "../assessment/assessmentChecklistStatusTag.vue";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'existingAssessmentDropdown',
  props: {
  name: {
    type: String,
    required: true,
  },
  checklistInforDetail: {
    type: Object,
    required: true,
  },
  date: {
    type: String,
    required: false,
    default: "",
  },
  isLarge: {
    type: Boolean,
    required: false,
    default: false,
  },
  history: {
    type: Array,
    required: false,
    default: () => [],
  },
  isExpanded: {
    type: Boolean,
    required: false,
    default: false,
  },
  index: {
    type: Number,
    required: false,
    default: -1,
  },
  isChecked: {
    type: Boolean,
    required: false,
    default: false,
  },
  selectedAssessmentParent: {
    type: Array,
    required: false,
    default: () => [],
  },
  assessmentSelectedId: {
    type: Number,
    required: false,
    default: -1,
  },
},
  emits: [
  "onToggle",
  "selectAssessment",
  "selectedParentAssessment",
],
  setup(__props, { emit }) {

const props = __props;



const isOpen = ref(props.isExpanded);
const selectedAssessments: Ref = ref([]);
const selectedAssessmentParentRef: any = ref([]);
const isSelected: Ref = ref(false);

watch(
  () => props.selectedAssessmentParent,
  (value) => {
    selectedAssessmentParentRef.value = value;
    if (value.length > 0) {
      selectedAssessments.value = [];
    }
  },
);
watch(
  () => selectedAssessments,
  (value) => {
    if (selectedAssessments.value.length > 0) {
      selectedAssessmentParentRef.value = [];
    }
  },
  { deep: true },
);
watch(
  () => props.isExpanded,
  () => {
    isOpen.value = props.isExpanded;
  },
);
watch(
  () => props.isChecked,
  () => {
    selectedAssessments.value = [];
    isSelected.value = false;
  },
);

const selectedParentAssessment = (data) => {
  emit("selectedParentAssessment", { data, index: props.index });
};
const selectedAssessment = (data) => {
  emit("selectAssessment", { data, index: props.index });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`${isOpen.value ? '' : 'tw-rounded-bl-[6px] tw-rounded-br-[6px]'} ${
        selectedAssessmentParentRef.value.includes(__props.index) ? 'selected' : ''
      } tw-overflow-x-auto tw-w-full tw-rounded-tl-[6px] tw-rounded-tr-[6px] tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-[5px] tw-self-stretch tw-border tw-px-[25px] tw-py-5 tw-border-solid tw-border-[#EFF0F1] tw-bg-[#FFFFFF]`)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createVNode(ToggleIcon, {
              ticked: selectedAssessmentParentRef.value.includes(__props.index),
              color: "#387DFF",
              onClick: _cache[0] || (_cache[0] = 
                () => {
                  isSelected.value = false;
                  selectedParentAssessment(__props.index);
                  selectedAssessments.value = [];
                }
              )
            }, null, 8, ["ticked"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(__props.name), 1),
            (__props.date)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " - "))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_6, _toDisplayString(__props.date), 1)
          ]),
          _createVNode(AssessmentChecklistStatusTag, {
            "checklist-status": __props.checklistInforDetail.checklistStatus,
            "checklist-status-id": __props.checklistInforDetail.checklistStatusId,
            "is-loading": false
          }, null, 8, ["checklist-status", "checklist-status-id"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", {
            class: "tw-cursor-pointer arrow",
            onClick: _cache[1] || (_cache[1] = 
              () => {
                isOpen.value = !isOpen.value;
                emit('onToggle', __props.index);
              }
            )
          }, [
            (_openBlock(), _createElementBlock("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "12",
              height: "8",
              viewBox: "0 0 12 8",
              fill: "none",
              style: _normalizeStyle(isOpen.value ? '' : 'transform: rotate(180deg)')
            }, _hoisted_9, 4))
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(`tw-w-full tw-flex tw-flex-col tw-items-start tw-gap-5 tw-self-stretch tw-p-5 tw-rounded-bl-[6px] tw-rounded-br-[6px] assessmentHistoryWrapper ${
        isOpen.value ? '' : 'close'
      }`)
    }, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessment-existing-assessment-dropdown-subtitle-assessment-history-1",
            )), 1),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.history as any, (assessment, _index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: _index,
              class: _normalizeClass(`tw-overflow-x-auto tw-flex tw-items-center tw-gap-[15px] tw-self-stretch tw-px-[25px] tw-py-[18px] assessment ${
              selectedAssessments.value.includes(assessment.checklistId) &&
              __props.assessmentSelectedId === assessment.checklistId
                ? 'selected'
                : ''
            } `)
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  _createVNode(ToggleIcon, {
                    ticked: 
                    selectedAssessments.value.includes(assessment.checklistId) &&
                    __props.assessmentSelectedId === assessment.checklistId
                  ,
                    color: "#387DFF",
                    onClick: 
                    () => {
                      isSelected.value = false;
                      if (
                        selectedAssessments.value.includes(assessment.checklistId) &&
                        __props.assessmentSelectedId === assessment.checklistId
                      ) {
                        selectedAssessments.value.splice(
                          selectedAssessments.value.indexOf(assessment.checklistId),
                          1,
                        );
                        selectedAssessments.value = [];
                      } else {
                        selectedAssessments.value = [];
                        selectedAssessments.value.push(assessment.checklistId);
                      }
                      selectedAssessment(_index);
                    }
                  
                  }, null, 8, ["ticked", "onClick"])
                ]),
                _createElementVNode("div", null, [
                  (_index === 0)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                    : (_openBlock(), _createElementBlock("img", _hoisted_15))
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", null, _toDisplayString(assessment.name || assessment.checklistName), 1),
                    (assessment.date || assessment.checklistDateCreated)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, " - "))
                      : _createCommentVNode("", true),
                    (assessment.date || assessment.checklistDateCreated)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(assessment.date ||
                      _unref(convertUTCTimeToLocalTime)(assessment.checklistDateCreated)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(AssessmentStatus, {
                  state: assessment?.checklistStatus
                }, null, 8, ["state"])
              ])
            ], 2))
          }), 128))
        ])
      ])
    ], 2)
  ]))
}
}

})